export default {
  components: {
    appUpdateBanner: {
      message: "A new version of Jasper is available.",
      updateButton: "Update",
    },
  },
};
